import { Box } from '@mui/material';
import { Outlet, useRouter } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import { useEffect } from 'react';

import { useCurrentUserQuery, UserRole } from 'entities/user';
import { Routes } from 'shared/routes';
import Loader from 'shared/ui/Loader';
import { Header } from 'widgets/header';
import { Sidebar } from 'widgets/sidebar';

import { styles } from './styles';

const ADMIN_ROLES = [UserRole.Admin, UserRole.Editor];

const AdminLayout = () => {
  const { data: currentUser, isLoading } = useCurrentUserQuery();
  const router = useRouter();

  const hasAdminAccess = currentUser && ADMIN_ROLES.includes(currentUser.role);

  useEffect(() => {
    if (!isLoading && !currentUser) {
      router.navigate({ to: Routes.frontend.loginPath });
    }

    if (!isLoading && currentUser && !hasAdminAccess) {
      router.navigate({ to: Routes.frontend.rootPath });
    }
  }, [currentUser, isLoading, hasAdminAccess]);

  if (isLoading) {
    return <Loader />;
  }

  if (!currentUser || !hasAdminAccess) {
    return <Loader />;
  }

  return (
    <Box sx={styles.root}>
      <Sidebar isAdminMode={true} userRole={currentUser.role} />
      <Box sx={styles.rightSide}>
        <Header isAdminMode={true} />
        <Box component="main" sx={styles.main}>
          <Box sx={styles.outletWrap}>
            <Outlet />
          </Box>
          <TanStackRouterDevtools />
        </Box>
      </Box>
    </Box>
  );
};

export { AdminLayout };
